import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { LoyaltyTier, LoyaltyTierReferralRule } from '../models/LoyaltyTier'
import { LOYALTY_TIERS_URL } from '../utils/urls'

const fetchLoyaltyTiers = (params: TableParams) =>
  SBAPI.FetchPaginated<LoyaltyTier[]>(LOYALTY_TIERS_URL, params)

const createLoyaltyTag = (tagName: string, loyaltyProviderId: number) =>
  SBAPI.Post(`${LOYALTY_TIERS_URL}/tags`, {
    tag: tagName,
    provider: loyaltyProviderId,
  })

const deleteLoyaltyTag = (loyaltyTagId: number) =>
  SBAPI.Delete(`${LOYALTY_TIERS_URL}/tags/${loyaltyTagId}`)

const fetchLoyaltyTiersReferralRules = () =>
  SBAPI.Fetch<LoyaltyTierReferralRule[]>(
    `${LOYALTY_TIERS_URL}/referral-rules`
  ).then((data) => data.data)

const updateLoyaltyTiersReferralRule = (
  loyaltyTierId: number,
  giveLoyaltyTierId: number
) =>
  SBAPI.Put(`${LOYALTY_TIERS_URL}/referral-rules`, {
    loyaltyTier: loyaltyTierId,
    giveLoyaltyTier: giveLoyaltyTierId ?? null,
  })

export {
  createLoyaltyTag,
  deleteLoyaltyTag,
  fetchLoyaltyTiers,
  fetchLoyaltyTiersReferralRules,
  updateLoyaltyTiersReferralRule,
}
